import { ERentioFormField } from "../../components/components/Form";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getValue } from "../../redux/form/form.utils";
import { EField } from "./schema.addAddress.types";
import { getMappedCountries } from "../../utils/location/location.utils";
export var getSchema = function (initialValues) {
    return function (defaultValues) {
        var _a;
        return ({
            required: [
                EField.Street,
                EField.Number,
                EField.City,
                EField.Zip,
                EField.Country,
            ],
            properties: (_a = {},
                _a[EField.Street] = {
                    default: getValue(EField.Street, initialValues, defaultValues),
                },
                _a[EField.Number] = {
                    default: getValue(EField.Number, initialValues, defaultValues),
                },
                _a[EField.Box] = {
                    default: getValue(EField.Box, initialValues, defaultValues),
                },
                _a[EField.Zip] = {
                    default: getValue(EField.Zip, initialValues, defaultValues),
                },
                _a[EField.City] = {
                    default: getValue(EField.City, initialValues, defaultValues),
                },
                _a[EField.Country] = {
                    default: getValue(EField.Country, initialValues, defaultValues),
                    // @ts-ignore
                    options: getMappedCountries(),
                },
                _a),
        });
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:navigationTitle": getLocalizedText("address.title"),
            "rentio:trackingKey": "address",
            "ui:field": ERentioFormField.Grid,
            grid: {
                row: [
                    {
                        col: {
                            width: [1, 50 / 100],
                            children: [EField.Street],
                        },
                    },
                    {
                        col: {
                            width: [1, 25 / 100],
                            children: [EField.Number],
                        },
                    },
                    {
                        col: {
                            width: [1, 25 / 100],
                            children: [EField.Box],
                        },
                    },
                    {
                        col: {
                            width: [1, 20 / 100],
                            children: [EField.Zip],
                        },
                    },
                    {
                        col: {
                            width: [1, 40 / 100],
                            children: [EField.City],
                        },
                    },
                    {
                        col: {
                            width: [1, 40 / 100],
                            children: [EField.Country],
                        },
                    },
                ],
            }
        },
        _a[EField.Street] = {
            "ui:field": extraData.withGoogleMapsInput
                ? ERentioFormField.AddressStreet
                : ERentioFormField.Text,
            title: getLocalizedText("address.street.label"),
            placeholder: extraData.withGoogleMapsInput
                ? getLocalizedText("address.street.placeholder")
                : getLocalizedText("address.street.label"),
        },
        _a[EField.Number] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("address.number.label"),
            placeholder: getLocalizedText("address.number.placeholder"),
        },
        _a[EField.Box] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("address.box.label"),
            placeholder: getLocalizedText("address.box.placeholder"),
            optional: true,
        },
        _a[EField.Zip] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("address.zip.label"),
            placeholder: getLocalizedText("address.zipcode.placeholder"),
        },
        _a[EField.City] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("address.city.label"),
            placeholder: getLocalizedText("address.city.placeholder"),
        },
        _a[EField.Country] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("address.country.label"),
            placeholder: getLocalizedText("address.country.placeholder"),
        },
        _a);
};
